export default "__VITE_ASSET__D67rtPY1__"